export default "ALTER TABLE `transactions` ADD `is_ignored` integer DEFAULT 0 NOT NULL;";